import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { DescriptionWrapper } from './components/DescriptionWrapper';

async function loadDescriptionStep(): Promise<typeof DescriptionWrapper> {
	return (
		await import(/* webpackChunkName: "pages/start-a-petition-steps-description" */ './components/DescriptionWrapper')
	).DescriptionWrapper;
}

export const DescriptionLoader: React.FC = () => {
	return (
		<LazyComponent
			loadComponent={loadDescriptionStep}
			fallback={
				<Box margin="auto">
					<Spinner />
				</Box>
			}
		/>
	);
};

export const preloadDescriptionStep = loadDescriptionStep;
